import { Getter } from "vuex";
import { IState } from './state';

const hits: Getter<IState, IState> = (state) => state.result.hits
const total: Getter<IState, IState> = (state) => state.result.total
const resultAmount: Getter<IState, IState> = (state) => state.result.amount
const amount: Getter<IState, IState> = (state) => state.result.amount
const query: Getter<IState, IState> = (state) => state.query
const filters: Getter<IState, IState> = (state) => state.filters
const showFilter: Getter<IState, IState> = (state) => state.showFilter
const date: Getter<IState, IState> = (state) => state.date

export default {
	hits,
    resultAmount,
    amount,
    query,
    filters,
    showFilter,
    date,
    total
}